<nz-collapse *ngIf="IsCollapse">
  <nz-collapse-panel nzHeader="Images" [nzActive]="true" [nzDisabled]="false">
    <div style="max-width: 100%">
      <ng-container [ngTemplateOutlet]="ImagesInfo"></ng-container>
    </div>
  </nz-collapse-panel>
  <nz-collapse-panel nzHeader="Files" [nzActive]="true" [nzDisabled]="false">
    <ng-container [ngTemplateOutlet]="FilesInfo"></ng-container>
  </nz-collapse-panel>
</nz-collapse>

<ng-template #ImagesInfo>
  <div cdkDropList class="cdkdrop-list" (cdkDropListDropped)="drop($event)">
    <div
      *ngFor="let item of ImagesMedia"
      style="display: inline-block; margin: 10px"
      [ngStyle]="{ height: size + 'px', width: size + 'px' }"
      cdkDrag
      class="cdkdrag-box"
    >
      <app-media
        *ngIf="item.isCover !== true"
        [mediaStructure]="item"
        (preview)="parentPreview($event)"
        (download)="fileDownload($event)"
        (remove)="removeFile($event)"
        (RoleChanges)="ChangeRole($event)"
        (CloseDrawer)="onCloseDrawer($event)"
      ></app-media>
    </div>
  </div>
</ng-template>
<ng-template #FilesInfo>
  <nz-row>
    <div *ngFor="let item of filesMedia" nz-col nzSpan="2">
      <app-media
        [mediaStructure]="item"
        (preview)="parentPreview($event)"
        (download)="fileDownload($event)"
        (remove)="removeFile($event)"
      ></app-media>
    </div>
  </nz-row>
</ng-template>

<ng-container *ngIf="JustImages" [ngTemplateOutlet]="ImagesInfo"></ng-container>
<ng-container *ngIf="JustFiles" [ngTemplateOutlet]="FilesInfo"></ng-container>

<div></div>
<div class="fixed-widget1" (mouseover)="hideSlider = false"></div>
<div class="fixed-widget"></div>

<div class="fixed-widgets">
  <nz-space>
    <button
      *nzSpaceItem
      type="button"
      nz-button
      nzType="default"
      nzShape="circle"
      title="Zoom in"
      (click)="zoomInOut(1)"
    >
      <i nz-icon nzType="zoom-in"></i>
    </button>
    <button
      type="button"
      *nzSpaceItem
      nz-button
      nzShape="circle"
      title="Zoom out"
      (click)="zoomInOut(0)"
    >
      <i nz-icon nzType="zoom-out"></i>
    </button>
    <button
      *nzSpaceItem
      type="button"
      nz-button
      nzType="default"
      nz-dropdown
      [nzDropdownMenu]="menu"
      (click)="fileUploadInput.click()"
      nzType="primary"
      nzShape="circle"
      title="Upload"
    >
      <i nz-icon nzType="upload"></i>
    </button>
  </nz-space>
</div>
<input
  #fileUploadInput
  type="file"
  id="input-file"
  nz-input
  multiple
  style="display: none"
  (change)="handleFileInput($event)"
/>
<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item (click)="uploadLink()">
      <a>{{'Linked Media' | translate}}</a>
    </li>
  </ul>
</nz-dropdown-menu>

<nz-drawer
  [nzWrapClassName]="'drawer-size-3x'"
  [nzVisible]="DrawerVisible"
  (nzOnClose)="onLinkDrawerClose()"
  [nzWidth]="'1000px'"
>
  <ng-container *nzDrawerContent>
    <nz-row>
      <div nz-col nzOffset="22" nzSpan="2">
        <button
          nz-button
          type="button"
          nzType="default"
          title="Save"
          (click)="handleLinkInput()"
        >
          {{'Save' | translate}}
          <i nz-icon nzType="save"></i>
        </button>
      </div>
    </nz-row>
    <br />
    <br />
    <nz-row>
      <div nz-col nzSpan="12">
        <nz-row>
          <div nz-col nzSpan="24">
            <nz-radio-group [(ngModel)]="LinkType">
              <label nz-radio nzValue="I">{{'Image' | translate}}</label>
              <label nz-radio nzValue="V">{{'Video' | translate}}</label>
            </nz-radio-group>
          </div>
        </nz-row>
        <br />
        <nz-row>
          <div nz-col nzSpan="4">{{'url' | translate}}</div>
          <div nz-col nzSpan="19">
            <textarea
              nz-input
              placeholder="type url "
              [nzAutosize]="{ minRows: 3, maxRows: 5 }"
              [(ngModel)]="mediaLink"
              (blur)="getYouTubeInfo()"
            ></textarea>
          </div>
        </nz-row>
        <br />
        <nz-row>
          <div nz-col nzSpan="4">{{'Title' | translate}}</div>
          <div nz-col nzSpan="19">
            <textarea
              nz-input
              placeholder="type title "
              nzAutosize
              [(ngModel)]="linkTitle"
              >{{ linkTitle }}</textarea
            >
          </div>
        </nz-row>
        <br />
        <nz-row>
          <div nz-col nzSpan="4">{{'Description' | translate}}</div>
          <div nz-col nzSpan="19">
            <textarea
              nz-input
              placeholder="type Description "
              [nzAutosize]="{ minRows: 5, maxRows: 10 }"
              >{{ videoDesciption }}</textarea
            >
          </div>
        </nz-row>
        <br />
        <nz-row>
          <div nz-col nzSpan="4">{{'Role' | translate}}</div>
          <div nz-col nzSpan="19">
            <nz-select
              nzMode="multiple"
              nzPlaceHolder="Please select roles"
              nzSize="default"
              style="width: 100%"
              [(ngModel)]="linkRols"
            >
              <nz-option nzLabel="Base" nzValue="1"></nz-option>
              <nz-option nzLabel="Small" nzValue="2"></nz-option>
              <nz-option nzLabel="Thumbnail" nzValue="3"></nz-option>
              <nz-option nzLabel="Swatch" nzValue="4"></nz-option>
            </nz-select>
          </div>
        </nz-row>
        <br />
        <nz-row *ngIf="LinkType === 'V'">
          <div nz-col nzSpan="6">{{'Upload Cover Image' | translate}}</div>
          <div nz-col nzSpan="17">
            <input
              type="file"
              id="input-file"
              nz-input
              (change)="handleCoverFileInput($event)"
            />
          </div>
        </nz-row>
      </div>
      <div nz-col nzOffset="4" nzSpan="8">
        <nz-row>
          <div nz-col nzSpan="24">
            <iframe
              *ngIf="LinkType === 'V'"
              width="400"
              height="400"
              [src]="
                mediaLink !== undefined && mediaLink !== ''
                  ? (mediaLink | safeHtml : 'resourceUrl')
                  : ''
              "
              frameborder="0"
              allowfullscreen
            ></iframe>
            <img
              *ngIf="LinkType === 'I'"
              nz-image
              [src]="mediaLink"
              [style.width.px]="400"
              [style.height.px]="400"
            />
          </div>
        </nz-row>
        <div
          *ngIf="
            LinkType === 'V' &&
            youtubeResult !== undefined &&
            youtubeResult.items[0] !== undefined &&
            youtubeResult.items[0].snippet !== undefined
          "
        >
          <nz-row>
            <div nz-col nzSpan="6" nzOffset="4">
              <p>{{'Published At:' | translate}}</p>
            </div>
            <div nz-col nzSpan="12">
              <p>{{ youtubeResult.items[0].snippet.publishedAt }}</p>
            </div>
          </nz-row>
          <nz-row>
            <div nz-col nzSpan="6" nzOffset="4">
              <p>{{'Publisher' | translate}}</p>
            </div>
            <div nz-col nzSpan="12">
              <a
                [href]="
                  'https://youtube.com/channel/' +
                  youtubeResult.items[0].snippet.channelId
                "
                >{{ youtubeResult.items[0].snippet.channelTitle }}</a
              >
            </div>
          </nz-row>
          <nz-row>
            <div nz-col nzSpan="6" nzOffset="4">
              <p>{{'Duration' | translate}}</p>
            </div>
            <div nz-col nzSpan="12">
              <p>
                {{
                  YTDurationToHour(
                    youtubeResult.items[0].contentDetails.duration
                  )
                }}
              </p>
            </div>
          </nz-row>
        </div>
      </div>
    </nz-row>
    <br />
    <nz-row>
      <div nz-col nzOffset="16">
        <img
          *ngIf="LinkType === 'V'"
          nz-image
          [src]="covertUrl"
          [style.width.px]="400"
          [style.height.px]="400"
        />
      </div>
    </nz-row>
  </ng-container>
</nz-drawer>
